import { render, staticRenderFns } from "./ResetFilter.vue?vue&type=template&id=12c8a56a"
import script from "./ResetFilter.vue?vue&type=script&lang=js"
export * from "./ResetFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports